/* eslint-disable global-require */

export default [
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-01.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-02.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-03.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-04.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-05.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-06.webp'),
  },
  {
    type: 'image',
    link: require('@/assets/images/homescapes/preview/de/preview-07.webp'),
  },
];
